module.exports = __webpack_public_path__ + "media/juicy-doja-cat.cc60eac2.mp3";